import type { KeyboardEvent } from "react";

export function stepSwitcherRows(event: KeyboardEvent<HTMLAnchorElement>) {
  if (event.key !== "ArrowDown" && event.key !== "ArrowUp") return;

  event.preventDefault();
  const list = event.currentTarget.closest("[data-switcher-list]");

  if (!(list instanceof HTMLElement)) {
    throw new Error("Switcher rows must be rendered inside the switcher list.");
  }

  const rows = Array.from(
    list.querySelectorAll<HTMLAnchorElement>("[data-switcher-row]"),
  );
  const index = rows.indexOf(event.currentTarget);
  const next = rows[index + (event.key === "ArrowDown" ? 1 : -1)];

  if (next) next.focus();
  else if (event.key === "ArrowUp")
    event.currentTarget
      .closest("fieldset")
      ?.querySelector<HTMLInputElement>("input")
      ?.focus();
}
